import gql from "graphql-tag";

export const INTERACT_WITH_AGENT_MUTATION = gql`
  mutation InteractWithAgent($input: AgentInteractionInput!) {
    interactWithAgent(input: $input) {
      statusCode
      message
      response
    }
  }
`;
